<template>
  <div
    class="mb-4 mt-2 flex space-x-4 overflow-x-auto"
    data-test="TCourseCreate-Colors"
  >
    <button
      v-for="color in colorList"
      :key="color.foreground"
      tabindex="0"
      :class="[
        'h-14 min-w-14 rounded-lg transition-transform  hover:scale-[.85]',
        color.background === selectedCourseColors?.background
          ? 'border-4 border-primary-500 '
          : '',
      ]"
      :style="{
        backgroundColor: color.background,
      }"
      data-test="TCourseCreate-CourseColor-Selector-Color"
      @click.prevent.stop="() => updateCourseColors(color)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import {courseColors, type CourseColor} from '../Course/course-colors';

const props = defineProps<{
  selectedCourseColors: CourseColor;
  updateCourseColors: (color: CourseColor) => void;
  preSelectedColor: CourseColor;
}>();

const colorList = ref<Array<CourseColor>>(courseColors);
if (props.preSelectedColor ) {
  const exists = courseColors.find(
    (color) =>
      color.background === props.preSelectedColor.background
  );
  if (!exists) {
    colorList.value = [props.preSelectedColor, ...courseColors];
  }
}
</script>
